import { connect } from 'react-redux'
import Header from './Header'

import selectIsFiltered from './Selectors/selectIsFiltered'

import onChangeSearch from './Handlers/onChangeSearch'
import onSearch from './Handlers/onSearch'
import onChangeFilter from './Handlers/onChangeFilter'
import onClickNew from './Handlers/onClickNew'

const mapStateToProps = (state) => ({
  subcontractors: state.core.subcontractors,
  projects: state.core.projects,
  users: state.core.users,
  search: state.screens.SubOrders.search,
  filters: state.screens.SubOrders.filters,
  isFiltered: selectIsFiltered(state),
})

const actionCreators = {
  onChangeSearch,
  onSearch,
  onChangeFilter,
  onClickNew,
}

export default connect(mapStateToProps, actionCreators)(Header)
